import { combineReducers } from "@reduxjs/toolkit";
import notificationSlice from "./notification/notification-slice";
import userSlice from "./user/user-slice";
import requestSlice from "./request-slice";
import errorSlice from "./error-slice";
import invEvSlice from "./finance/inv-ev/inv-ev-slice";
import missionControlSlice from "./mission-control/mission-control-slice";
import stakeholderSlice from "./mandatoryFields/stakeholder-slice";
import templateSlice from "./master/template-slice";
import reportSlice from "./report/report-slice";
import formVisibilitySlice from "./form-visibility/form-visibility-slice";
import stkSlice from "./stakeholder/stk-slice";
import dynamicColumnSlice from "./jobMoniter/dynamic-column-slice";
import formGeneratorSlice from "./form-generator/form-generator-slice";

const rootReducer = combineReducers({
  notification: notificationSlice.reducer,
  user: userSlice.reducer,
  request: requestSlice.reducer,
  error: errorSlice.reducer,
  template: templateSlice.reducer,
  invEv: invEvSlice.reducer,
  missionControl: missionControlSlice.reducer,
  stakeholder: stakeholderSlice.reducer,
  report: reportSlice.reducer,
  formVisibility: formVisibilitySlice.reducer,
  stk: stkSlice.reducer,
  dynamicColumn: dynamicColumnSlice.reducer,
  formGenerator: formGeneratorSlice.reducer,
});

export default rootReducer;
